var Status;
(function (Status) {
    Status["APPROVED"] = "approved";
    Status["AVAILABLE"] = "available";
    Status["AWAITING_APPROVAL"] = "awaitingapproval";
    Status["CANCELED"] = "canceled";
    Status["CONFIRMED"] = "confirmed";
    Status["DONE"] = "done";
    Status["MISSED"] = "missed";
    Status["NONE"] = "";
    Status["NOT_APPROVED"] = "notapproved";
    Status["PROCESSING"] = "processing";
    Status["READY"] = "ready";
    Status["WAITING"] = "waiting";
})(Status || (Status = {}));
export default Status;
//# sourceMappingURL=status.js.map